// export const API = "https://mukbiz-backend.onrender.com";
// export const API = "http://localhost:3001";
export const API = process.env.REACT_APP_API_URL;